<template>
  <div id="indexheaderDiv">
    <el-row>
      <el-col :xs="24" :md="4">
        <div class="logo">
          <img v-show='logimage' src="../../../static/images/Logo.png" />
          <img v-show='logimage2'  style="width:70px;" src="../../../static/images/logo01.png" />
        </div>
      </el-col>
      <el-col :xs="24" :md="4">
        <div style="color: #fbfcfe; margin-top: 20px;font-weight: bold;">
          Welcome to H3C iSLH system.
        </div>
      </el-col>
      <el-col :xs="24" :md="16">
        <div class="layout-ceiling">
          <!-- <Dropdown @on-click="changelocal">
              <a href="#"> {{$t(this.localelang)}} </a>
              <Icon type="ios-arrow-down" size='6px'></Icon> 
              <DropdownMenu slot="list">
                  <DropdownItem  name='zh'>简体中文</DropdownItem>
                  <DropdownItem  name='en'>English</DropdownItem>              
              </DropdownMenu>
          </Dropdown>
          <Divider type="vertical" /> -->


          
          
          
          <el-dropdown trigger="click">
            <span style="cursor: pointer;">{{loginname}}<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="accountType === 'external'"><span @click="changePassword">{{$t("updatePassword")}}</span></el-dropdown-item>
              <el-dropdown-item><span @click="setLocation">{{$t("setLocation")}}</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span>{{'System Role：'}}{{roleName}}</span>
          <Divider type="vertical" />

          <span>{{'Current Location：'}}<el-link @click="setLocation" type="danger">{{uLocation}}</el-link></span>
          <Divider type="vertical" />

          <ITService/>
          <Divider type="vertical" />
          <Tooltip placement="top" theme="light" :delay="1500">
            <span style="cursor: pointer;" @click="loginOut">{{$t('login_out')}}</span>
            <div slot="content">
              <p>{{$t('login_out')}}</p>
            </div>
          </Tooltip>     
        </div>
      </el-col>
    </el-row>
    <!--修改密码-->
    <Modal v-model="modelUpdatePassword" :closable='false' :mask-closable='false' :title="$t('updatePassword')">
      <div slot="footer">
        <Button type="primary" size="small"  @click="cancel">{{$t('cancle')}}</Button>
        <Button type="primary" size="small"  @click="submitUserForm('updatePasswordForm')">{{$t('confrim')}}</Button>
      </div>
      <el-form :model="updatePasswordForm" ref="updatePasswordForm" :rules="rules" label-width="150px">
        <el-form-item :label="$t('oldpwd')" prop="password" >
          <el-input clearable v-model="updatePasswordForm.password" type="password" :placeholder="$t('password')" style="width: 270px;"/>
        </el-form-item>
        <el-form-item :label="$t('newpwd')" prop="password1" >
          <el-input clearable v-model="updatePasswordForm.password1" type="password" :placeholder="$t('password')" style="width: 270px;"/>
        </el-form-item>
        <el-form-item :label="$t('verifypwd')" prop="password2" >
          <el-input clearable v-model="updatePasswordForm.password2" type="password" :placeholder="$t('password')" style="width: 270px;"/>
        </el-form-item>
      </el-form>
    </Modal>
    <!--设置location-->
    <Modal v-model="modelLocation" id="suffixId" :closable='true' :mask-closable='false' :title="$t('setLocation')">
      <div slot="footer">
        <Button type="primary" size="small"  @click="cancel">{{$t('cancle')}}</Button>
        <Button type="primary" size="small"  @click="submitLocation('locationForm')">{{$t('confrim')}}</Button>
      </div>
      <el-form :model="locationForm" ref="locationForm" :rules="rules" label-width="100px">
        <el-form-item :label="$t('userLocation')" prop="userLocation" >
          <el-select v-model="locationForm.userLocation" clearable filterable>
            <el-option v-for="item in LocationList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </Modal>
    <!--必填location-->
    <Modal v-model="modelRequiredLocation" id="suffixId" :closable='false' :mask-closable='false' :title="$t('setLocation')">
      <div slot="footer">
        <Button type="primary" size="small"  @click="submitLocation('locationForm')">{{$t('confrim')}}</Button>
      </div>
      <el-form :model="locationForm" ref="locationForm" :rules="rules" label-width="100px">
        <el-form-item :label="$t('userLocation')" prop="userLocation" >
          <el-select v-model="locationForm.userLocation" clearable filterable>
            <el-option v-for="item in LocationList" :key="item.sysValue" :label="item.sysValue" :value="item.sysValue"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </Modal>
  </div>

</template>

<script>
import * as validate from '@/utils/validate'
  import ITService from './IT_Service.vue'

  export default {
    name: 'H3cHeader',
      components: {
        ITService
      },
      mounted() {
        // this.$i18n.locale 要传key
        this.locale = this.$i18n.locale;
        this.changeLangFn(this.locale);
        if(this.locale=='zh'){
          this.imgSrc='../../../static/images/Logo.png'
          this.logimage=true
          this.logimage2=false                   
        }else if(this.locale=='en'){
          this.imgSrc='../../../static/images/logo01.png'
          this.logimage=false
          this.logimage2=true                  
        }
      },
      data () {
        var checkPassword = (rule, value, callback) => {
          let params = {
            password : value,
            islhToken : sessionStorage.getItem('islhtoken'),
          }
          let url =`${this.$store.state.islhurl}checkUserPassword`
          this._post(url,params).then(
            res => {      
              if(res == 0){
                var msg = this.$t('pwdEror')
                return callback(new Error(msg));
              }else if(res == 1){
                var msg = this.$t('SystemError')
                return callback(new Error(msg));
              }else{
                callback();
              }
            }
          )
        };
        var checkPassword1 = (rule, value, callback) => {
          let password = this.updatePasswordForm.password;
          let reg = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[._~!@#$^&*])[A-Za-z0-9._~!@#$^&*]{8,20}$/;
          if(value == password){
            var msg = this.$t('loginErrorMsg9')
            return callback(new Error(msg));
          }else if(!reg.test(value)){
            return callback(new Error('Password length is 8-20 bits, including upper and lower case letters, numbers, special symbols'));
          }else{
            callback();
          }
        };
        var checkPassword2 = (rule, value, callback) => {
          let password = this.updatePasswordForm.password1;
          if(password != value){
            var msg = this.$t('loginErrorMsg8')
            return callback(new Error(msg));
          }else{
            callback();
          }
        }
        return {
          uLocation:null,
          accountType:'',
          logimage:true,
          logimage2:false,             
          imgSrc: "",
          userAccount:'',
          localelang:'languages',
          locale: [],
          passwordchange:'',
          loginname:'',
          roleName:null,
          modelUpdatePassword: false,
          modelLocation:false,
          modelRequiredLocation:false,
          changeLang: [
            {value: "zh",label: "简体中文"},
            {value: "en",label: "English"}
          ],
          updatePasswordForm:{
            password:'',
            password1:'',
            password2:'',
          },
          locationForm:{
            userLocation:null,
          },
          LocationList:[],
          rules: {
            password: [
              { required: true, message:'Please input the Password', trigger: 'blur' },
              { validator:checkPassword, trigger: 'blur' }
            ],
            password1: [
              { required: true, message:'Please input the Password', trigger: 'blur' },
              { validator:checkPassword1, trigger: 'blur' }
            ],
            password2: [
              { required: true, message:'Please input the Password', trigger: 'blur' },
              { validator:checkPassword2, trigger: 'blur' }
            ],
            userLocation: [
              { required: true, message:'Please select location', trigger: 'change' },
            ],
          },
        }
      },
      created(){
        this.getUserInformation();//获取用户信息，显示
        this.getLocation();
      },    
      methods: {     
        changeLangFn(val) {
          let chan = this.changeLang;
          for (let i in chan) {
            if (chan[i].value === val) {
              this.locale = this.$i18n.locale = chan[i].value;
              localStorage.setItem("language", chan[i].value);
            }
          }
        },
        changelocal(name){
          if(name=='zh'){
            this.$i18n.locale='zh'
            this.localelang='简体中文'
            this.imgSrc='../../../static/images/Logo.png'
            this.logimage=true
            this.logimage2=false
          }else{
            this.$i18n.locale='en'
            this.localelang='English'
            this.imgSrc='../../../static/images/logo01.png'
            this.logimage=false
            this.logimage2=true
          }
        },
        getLocation(){
          let url =`${this.$store.state.islhurl}keyValue/getLocation`;
          let pm = {
            sysKey: 'Country',
            delFlg: '0',
          }
          this._post(url,pm).then(
            res => {   
              this.LocationList = res.data;
            }
          )
        },
        getUserInformation(){
          let url = `${this.$store.state.islhurl}getUserInformationApi`
          let parms = {
            islhToken : sessionStorage.getItem('islhtoken'),
          }
          this._post(url,parms).then(
            res =>{
              this.loginname = res.empName;
              this.roleName = res.roleName;
              this.userAccount = res.userAccount;
              this.accountType = res.accountType;
              if(res.userLocation == null || res.userLocation == ""){
                this.modelRequiredLocation = true;
              }else{
                this.uLocation = res.userLocation;
              }
              sessionStorage.setItem('roleName', res.roleName);
              localStorage.setItem('TY_USER_ID', res.userAccount);
              localStorage.setItem('DOMAIN_ACCOUNT', res.empCode);
            }
          )
        },
        loginOut(){
          let url = `${this.$store.state.islhurl}logoutApi`
          this._get(url).then(
            res =>{
              if(res=='out'){
                sessionStorage.removeItem('islhtoken');
                sessionStorage.removeItem('eostoken');
                sessionStorage.removeItem('userRolePerm');
                localStorage.removeItem('TY_USER_ID');
                localStorage.removeItem('DOMAIN_ACCOUNT');
                this.$router.push({
                  path:'/login'
                })
              }
            }
          )
        },
        submitUserForm(formName){
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.confrimUpdate();
            } else {
              return false;
            }
          });
        },
        confrimUpdate(){
          let url = `${this.$store.state.islhurl}updatePassword`
          let parms = {
            islhToken : sessionStorage.getItem('islhtoken'),
            password : this.updatePasswordForm.password1,
          }
          this._post(url,parms).then(
            res =>{
              if(res=='0'){
                this.modelUpdatePassword=false;
                var msg = this.$t('pwdSuccess')
                this.$Message.success(msg);
              }else{
                var msg = this.$t('SystemError')
                this.$Message.success(msg);
              }
            }
          )
        },
        setLocation(){
          this.locationForm.userLocation = this.uLocation;
          this.modelLocation = true
        },
        submitLocation(formName){
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.updateLocation();
            } else {
              return false;
            }
          });
        },
        updateLocation(){
          let parms = {
            islhToken : sessionStorage.getItem('islhtoken'),
            userLocation : this.locationForm.userLocation,
          }
          let url = `${this.$store.state.islhurl}modifyLocation`
          this._post(url,parms).then(
            res =>{
              if(res == '200'){
                this.uLocation = parms.userLocation;
                this.modelLocation = false;
                this.modelRequiredLocation = false;
                this.$Message.success(this.$t('modifySus'));
              }else{
                this.$message({
                  type:'error',
                  showClose:true,
                  duration:10000,
                  message:res
                });
              }
            }
          )
        },
        changePassword(){
          this.updatePasswordForm.password = null;
          this.updatePasswordForm.password1 = null;
          this.updatePasswordForm.password2 = null;
          this.$refs.updatePasswordForm.resetFields();
          this.modelUpdatePassword=true
        },
        cancel(){
          this.modelUpdatePassword = false;
          this.modelLocation = false;
        },
      }
  }
</script>

<style lang="less" type="text/less">
  #indexheaderDiv{
    width: 100%;
    height: 60px;
    font-size: 14px;
    background:rgba(1,122,255,1);
    .logo{
        display: inline;
    }
    .logo img{
        margin: 16px 0 15px 20px;
    }
    .layout-ceiling{
        color:rgba(251,252,254,1) !important;
        margin-right: 20px;
        float: right;
        margin-top: 20px;
    }
    .layout-ceiling  a {
        color:#7aff00 !important;
    }
    .el-dropdown{
      color:white;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/public/header.vue